/*
 * SIJL - koffie met een doosje bonbons erbij.
 *
 * Hoort bij snippets/sijl-koffie-combo.liquid. Dat bestand zet de gegevens
 * klaar, dit bestand doet het rekenwerk en het toevoegen aan de winkelwagen.
 *
 * Twee dingen om te weten als je hier ooit in moet:
 *
 * 1. Het blok laat zich alleen zien als de koffie en het doosje samen boven de
 *    drempel voor gratis verzending uitkomen. Blijft de som eronder, dan zwijgt
 *    het. Een belofte van gratis verzending die bij het afrekenen niet uitkomt
 *    is erger dan geen aanbod - zeker omdat koffie en bonbons uit verschillende
 *    verzendprofielen komen en de tarieven dan bij elkaar opgeteld worden.
 *
 * 2. De regels die naar de bakkerij gaan (Rij 1, Rij 2, ...) moeten er precies
 *    zo uitzien als wanneer de klant het doosje zelf had samengesteld. Het
 *    doosje van 10 is een honingraat van 3-4-3, het doosje van 35 een raster
 *    van zeven breed. Verandert die indeling in sijl-bonbon-buy-box.liquid,
 *    dan moet dat hier mee.
 */

(function () {
  'use strict';

  var blok = document.querySelector('[data-sijl-combo]');
  if (!blok) return;

  var bron = blok.querySelector('[data-sijl-combo-config]');
  if (!bron) return;

  var config;
  try {
    config = JSON.parse(bron.textContent);
  } catch (e) {
    return;
  }

  if (!config.smaken || config.smaken.length === 0) return;

  var onderdelen = {
    doosfoto: blok.querySelector('[data-sijl-combo-doosfoto]'),
    kop: blok.querySelector('[data-sijl-combo-kop]'),
    uitleg: blok.querySelector('[data-sijl-combo-uitleg]'),
    smaken: blok.querySelector('[data-sijl-combo-smaken]'),
    knop: blok.querySelector('[data-sijl-combo-knop]'),
    knoptekst: blok.querySelector('[data-sijl-combo-knoptekst]'),
    voet: blok.querySelector('[data-sijl-combo-voet]')
  };

  var bezig = false;

  function prijs(centen) {
    return '€' + (centen / 100).toFixed(2).replace('.', ',');
  }

  /* Welk gewicht staat er nu aangevinkt? De koopkolom zet de klasse active op
     het gekozen label; valt dat weg, dan pakken we het aangevinkte radiootje. */
  function huidigeVariant() {
    var gekozen = document.querySelector('.sijl-weight-option.active[data-id]');
    var id = gekozen ? gekozen.dataset.id : null;

    if (!id) {
      var radio = document.querySelector('input[name="id"]:checked');
      if (radio) id = radio.value;
    }

    if (!id) {
      var verborgen = document.querySelector('input[name="id"]');
      if (verborgen) id = verborgen.value;
    }

    for (var i = 0; i < config.varianten.length; i++) {
      if (String(config.varianten[i].id) === String(id)) return config.varianten[i];
    }

    return config.varianten[0] || null;
  }

  /* De vakjes vullen door de smaken rond te draaien. Zo zitten er nooit twee
     dezelfde naast elkaar en komen de aantallen vanzelf gelijk uit: bij vier
     smaken in een doosje van tien wordt het 3-3-2-2. */
  function vulDoosje(aantal) {
    var namen = [];
    for (var i = 0; i < aantal; i++) {
      namen.push(config.smaken[i % config.smaken.length].naam);
    }
    return namen;
  }

  /* De verborgen regel met de bestandsnamen van de foto's, in doosvolgorde. De
     bevestigingsmail en de pakbon tekenen daar het doosje mee. Begint met een
     underscore, dus de klant ziet hem nergens. */
  function fotosVan(aantal) {
    var lijst = [];
    for (var i = 0; i < aantal; i++) {
      var bron = config.smaken[i % config.smaken.length].foto || '';
      lijst.push(bron ? bron.split('/').pop().split('?')[0] : '');
    }
    return lijst.join(',');
  }

  /* Dezelfde eigenschappen als het samenstelformulier maakt. */
  function rijenVan(namen, doos) {
    var rijen = {};
    var rij = 1;
    var index = 0;

    if (doos.honingraat) {
      for (var h = 0; h < doos.honingraat.length; h++) {
        var stuk = namen.slice(index, index + doos.honingraat[h]);
        if (stuk.length) rijen['Rij ' + rij] = stuk.join(' | ');
        index += doos.honingraat[h];
        rij += 1;
      }
      return rijen;
    }

    var kolommen = doos.kolommen || namen.length;
    while (index < namen.length) {
      var deel = namen.slice(index, index + kolommen);
      if (deel.length) rijen['Rij ' + rij] = deel.join(' | ');
      index += kolommen;
      rij += 1;
    }
    return rijen;
  }

  function toonSmaken() {
    onderdelen.smaken.innerHTML = '';
    var tonen = config.smaken.slice(0, 6);

    tonen.forEach(function (smaak) {
      var li = document.createElement('li');
      li.className = 'sijl-combo__smaak';
      li.title = smaak.naam;
      if (smaak.foto) {
        var img = document.createElement('img');
        img.src = smaak.foto;
        img.alt = smaak.naam;
        img.loading = 'lazy';
        img.width = 30;
        img.height = 30;
        li.appendChild(img);
      }
      onderdelen.smaken.appendChild(li);
    });

    if (config.smaken.length > tonen.length) {
      var rest = document.createElement('li');
      rest.className = 'sijl-combo__meer';
      rest.textContent = '+' + (config.smaken.length - tonen.length);
      onderdelen.smaken.appendChild(rest);
    }
  }

  function teken() {
    var variant = huidigeVariant();
    if (!variant || !variant.beschikbaar) {
      blok.hidden = true;
      return;
    }

    var doos = config.dozen[variant.doos];
    if (!doos) {
      blok.hidden = true;
      return;
    }

    var samen = variant.prijs + doos.prijs;

    /* Haalt de som de drempel niet, dan tonen we niets. Zie de toelichting
       bovenaan dit bestand. */
    if (samen < config.drempel) {
      blok.hidden = true;
      return;
    }

    blok.hidden = false;
    blok.dataset.doos = variant.doos;

    if (doos.foto) {
      onderdelen.doosfoto.src = doos.foto;
      onderdelen.doosfoto.alt = doos.titel;
    }

    /* De kop noemt eerst het product en pas daarna het voordeel. De zin eronder
       herhaalt de gratis verzending dus niet meer; die staat in de kop en in de
       voetregel hieronder. */
    onderdelen.kop.textContent = 'Combineer de koffiebonen met bonbons en ontvang gratis verzending';
    onderdelen.uitleg.textContent =
      doos.aantal + ' handgemaakte bonbons, uitgezocht bij het smaakprofiel van deze boon.';

    onderdelen.knoptekst.textContent = 'Allebei in de winkelwagen - ' + prijs(samen);
    onderdelen.knop.disabled = false;

    onderdelen.voet.innerHTML = '';
    var los = document.createElement('span');
    los.textContent =
      'Het doosje kost ' + prijs(doos.prijs) + ', samen boven de ' + prijs(config.drempel) +
      '. Liever zelf kiezen? ';
    var link = document.createElement('a');
    link.href = doos.url;
    link.textContent = 'Stel je eigen doosje samen';
    onderdelen.voet.appendChild(los);
    onderdelen.voet.appendChild(link);

    toonSmaken();
  }

  function toevoegen() {
    if (bezig) return;

    var variant = huidigeVariant();
    if (!variant) return;

    var doos = config.dozen[variant.doos];
    if (!doos) return;

    var namen = vulDoosje(doos.aantal);
    var eigenschappen = rijenVan(namen, doos);
    eigenschappen._fotos = fotosVan(doos.aantal);

    bezig = true;
    onderdelen.knop.disabled = true;
    onderdelen.knoptekst.textContent = 'Bezig...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          { id: variant.id, quantity: 1 },
          { id: doos.variantId, quantity: 1, properties: eigenschappen }
        ]
      })
    })
      .then(function (antwoord) {
        if (!antwoord.ok) throw new Error('winkelwagen');
        return antwoord.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        bezig = false;
        onderdelen.knop.disabled = false;
        onderdelen.knoptekst.textContent = 'Niet gelukt, probeer opnieuw';
      });
  }

  onderdelen.knop.addEventListener('click', toevoegen);

  /* De koopkolom zet de klasse active pas na zijn eigen klikafhandeling, dus we
     wachten een tel voordat we opnieuw tekenen. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') window.setTimeout(teken, 0);
  });

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.sijl-weight-option')) {
      window.setTimeout(teken, 0);
    }
  });

  teken();
})();
